<!-- Content -->
<div class="px-6 py-4">
  <p class="text-slate-700" [innerHTML]="mensaje()"></p>
  @if (showInput() == true) {
    <input
      type="text"
      [(ngModel)]="valorInput"
      class="mt-4 w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400"
    />
  }
</div>

<!-- Footer -->
<div class="border-t border-slate-100 px-6 py-4 flex gap-3 justify-end">
  @if (textoCancel() != '') {
    <button
      (click)="onCancel()"
      [disabled]="loading()"
      class="px-4 py-2 text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 font-medium transition disabled:opacity-50"
    >
      {{ textoCancel() }}
    </button>
  }
  <button
    (click)="onConfirm()"
    [disabled]="loading()"
    class="px-4 py-2 text-white bg-accent-600 rounded-lg hover:bg-accent-500 font-medium transition disabled:opacity-50 inline-flex items-center gap-1 shadow-sm"
  >
    @if (loading()) {
      <i class="bi bi-arrow-repeat animate-spin"></i>
    }
    {{ textoConfirm() }}
  </button>
</div>
